import { renderStockforgePlusIcon } from "@shared/ui/stockforgePlusIcon";
import type { WebTabDef } from "./tabBar";
import { tabUsesStockForgeData } from "./tabBar";

export {
  WEB_TAB_BAR,
  bodyAttrForTab,
  findWebTabDef,
  tabButtonAttrs,
  tabButtonClasses,
  tabButtonInnerHtml,
  tabUsesStockForgeData,
  visibleWebTabs,
} from "./tabBar";

const STOCKFORGE_ORIGIN = "https://thestockforge.com";

export function formatWheelUpdated(at = Date.now(), now = Date.now()): string {
  const secs = Math.max(0, Math.floor((now - at) / 1000));
  if (secs < 60) {
    const n = secs <= 0 ? 1 : secs;
    return `Upd: ${n} sec`;
  }
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `Upd: ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `Upd: ${hours} hr`;
  const days = Math.floor(hours / 24);
  return `Upd: ${days} day${days === 1 ? "" : "s"}`;
}

export function renderSiteHeaderHtml(
  statusIndicatorsHtml = "",
  feedIndicatorHtml = "",
  buyingPowerHtml = "",
): string {
  return `
    <header class="top">
      <a class="brand" href="/web/" title="StockForge+">
        ${renderStockforgePlusIcon(26, "logo-mark sfe-brand-icon")}
        <span class="sfe-brand-wordmark">StockForge<b>+</b></span>
      </a>
      ${
        statusIndicatorsHtml
          ? `<div class="row sfe-web-header-status">${statusIndicatorsHtml}</div>`
          : ""
      }
      <div class="dash-header-rest" id="dashHeaderRest">
        <div class="spacer"></div>
        <div class="dash-header-actions">
          ${feedIndicatorHtml ? `<div class="sfe-web-header-feed">${feedIndicatorHtml}</div>` : ""}
          ${buyingPowerHtml}
          <button type="button" class="pill nav-pill sfe-web-logout-btn" id="sfeWebLogoutBtn" data-action="header-logout" aria-label="Sign out" title="Sign out" hidden><svg class="sfe-web-toolbar-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3"/></svg></button>
        </div>
      </div>
    </header>
  `;
}

export function renderSiteFooterHtml(): string {
  return `
    <footer class="sfe-web-site-footer">
      <a class="sfe-stockforge-site-link" href="${STOCKFORGE_ORIGIN}/dashboard" target="_blank" rel="noopener noreferrer">Original Stock Forge</a>
    </footer>
  `;
}

export function applyWheelTabButtonClasses(
  button: HTMLButtonElement,
  tab: WebTabDef,
  active: boolean,
): void {
  button.classList.add("small", "sfe-web-tab");
  button.setAttribute("aria-selected", active ? "true" : "false");
  button.classList.toggle("sfe-web-tab-sf-source", tabUsesStockForgeData(tab.id));
  if (tabUsesStockForgeData(tab.id)) {
    button.setAttribute("data-sf-source", "true");
    if (!button.title) button.title = "Main data from Stock Forge";
  } else {
    button.removeAttribute("data-sf-source");
  }

  if (tab.kind === "injected") {
    button.classList.remove("active");
    button.classList.add("ghost");
    button.classList.toggle("sfe-tab-selected", active);
    return;
  }

  button.classList.remove("sfe-tab-selected");
  button.classList.toggle("active", active);
  button.classList.toggle("ghost", !active);
}
